import { useQuery } from "@tanstack/react-query";
import { SegmentRepository } from "../../domain/interfaces/SegmentRepository";
import { SegmentEntity } from "../../domain/segment.entity";
import { segmentsQueryKeys } from "../../infrastructure/cache/SegmentsCacheStrategy";

interface UseSegmentsOptions {
  enabled?: boolean;
}

export function useSegments(
  propertyTicker: string,
  repository: SegmentRepository,
  { enabled = true }: UseSegmentsOptions = {}
) {
  return useQuery({
    queryKey: segmentsQueryKeys.list(propertyTicker),
    queryFn: (): Promise<SegmentEntity[]> => repository.findByProperty(propertyTicker),
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
